export default __webpack_public_path__ + "static/media/Mrs_Barry.a00f6ef5.png";